/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'

import globals from './globals'
import Popper from 'popper.js'
import Vuex from 'vuex'
import CryptoJS from 'crypto-js';
import axios from 'axios'

const productionURL = 'https://web.fitlistapp.com'
const stagingURL = 'https://fitlist-staging.sixsidedstudio.com'

let isDev = false
let apiURL = isDev ? stagingURL : productionURL

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use({
    install (Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: apiURL
    })
  }
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
  	profile: {
  		name: '',
      subscription: {
        subscription_type: {
          role: ''
        }
      }
  	},
  	user: null,
    user_token: null,
    role: '',
    subscription: ''
  },
  mutations: {
    setProfileName (state, name) {
      let saved_name = (name !== null) ? name : ''
  		state.profile.name = saved_name
  		localStorage.setItem('profile_name', saved_name)
  	},
  	saveUserProfile (state, data) {
  		state.user = data
      localStorage.setItem('user', JSON.stringify(data))
  	},
    saveUserToken ( state, data) {
      state.user_token = data
    },
    setRole (state, data) {
      state.role = data
      localStorage.setItem('fitlist-role', data)
    },
    setSubscription (state, data) {
      state.subscription = data
      localStorage.setItem('fitlist-sub', data);
    },
    setAuthentication (state, data) {
      state.authenticated = data
      localStorage.setItem('fitlist-auth', data);
    }
  },
  actions: {

  },
  getters: {
  	profileName (state) {
      if (state.profile.name !== null) {
    		if (state.profile.name.length > 0) {
    			return state.profile.name
    		} else {
    			return localStorage.getItem('profile_name')
    		}
      } else {
        return ''
      }
  	},
    profile (state) {
      if (state.user !== null) {
        return state.user
      } else if (localStorage.getItem('user') !== null) {
        return JSON.parse(localStorage.getItem('user'))
      } else {
        return { avatar: 'avatars/original/missing.png' }
      }
    },
    role (state) {
      if (state.role !== '') {
        return state.role
      }
      else {
        return localStorage.getItem('fitlist-role')
      }
    },
    subscription (state) {
      if (state.subscription !== '') {
        return state.subscription
      }
      else {
        return localStorage.getItem('fitlist-sub')
      }
    },
    userToken (state) {
      console.log('user token')

      let token = [];

      if (state.user_token !== null) {
        token.push(state.user_token)
      }
      else {
        token = document.cookie.split(';').filter(function(item) {
          return item.trim().indexOf('user_token=') == 0
        })
      }

      if (token.length > 0 && localStorage.getItem('user') !== null) {
        let k = 'fitlist' + JSON.parse(localStorage.getItem('user')).id
        //return token[0].split('=')[1]
        let tokenVal = token[0].split('=')[1]
        let bytes  = CryptoJS.AES.decrypt(tokenVal, k);
        let user_token = bytes.toString(CryptoJS.enc.Utf8)
        return user_token
      }
      else {
        return null
      }
        // Encrypt
       /* var ciphertext = CryptoJS.AES.encrypt('my message', 'secret key 123').toString();
        console.log(ciphertext);
        // Decrypt
        var bytes  = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
        var originalText = bytes.toString(CryptoJS.enc.Utf8);

        console.log(originalText); // 'my message'*/

      /*if (state.user_token !== null) {
        return state.user_token
      }
      else {*/
     /* }*/
    }
  },
})

// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
